import { NumericType } from "src/shared/models/metric";

export interface CxoneGaugeModuleData {
    Error: ErrorCode;
    GaugeData: GaugeObject;
}

export interface GaugeObject {
    Direction?: GaugeDirection;
    DisplayValue?: string;
    MetricId?: number;
    MetricName?: string;
    NumericType?: NumericType;
    Objective?: Objective;
    Value?: number;
    Min?: number;
    Max?: number;
    PoValueColor?: string;
    TimeType: TimeType;
}

export enum TimeType {
    None = 0,
    Second = 1,
    Minute = 2,
    Hour = 3,
    Time = 4
}

export interface Objective {
    Values: number[],
    ColorRange: ColorRange
    Min?: number;
    Max?: number;
    PoValueColor?: string
}

export interface ColorRange {
    HexColor: string[],
    RgbaColor: string[]
    ColorLabel: string[]
}
export interface PlotbandsObj {
    from: number,
    to: number,
    color: string
    thickness: string,
    borderColor: string,
    borderWidth: number,
    events?: object
}

export enum ErrorCode {
    NoError = 0,
    NoMetric = 1,
    DateRangeToWideIntraDay = 2,
}

export enum GaugeDirection {
    Up = 0,
    Down = 1,
    SweetSpot = 2,
}

export enum GaugeModuleDisplay {
    Compact = "compact",
    Detailed = "detailed"
}